module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAbFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8+T+BWAAAAI3RSTlMA4MDS/PjmcR0S8t3Wp6GYYTAF7Mq0mZGBgGZVU0lEOi0YDy6b3zwAAACNSURBVDjL3dDJDoMwDEXRxxBISilD57nF//+PJMILpMRhizjba8nSw/ZcaLIXulELByWxUjjIuCsT7h2xA8KuxL7h3h+5Zwh7EStSq4HnTHMnr//zeU+0MALb/YQRmPrAVycWv2khMFO/QfLkIUWN62kPUeV2HOSu3YwastYO0CGipvyNmIIeiKruWKcR0Y4WNmXemPMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/newStatic/img/video/ic_sptc_lightning@2x(1)(1).png
// module id = +sM2
// module chunks = 88